import { get as getCookie } from 'js-cookie';

import { COOKIES_UTM_MAP } from '../../../constants';
import { onlyDigits } from '../../../utils/format';
import type { ISendFormPresaleRequest, ISendFormDefaultRequest } from '../../../helpers/models';
import type { TInnStatus } from '../models';

/**
 * Создаёт метку времени ISO 8601 в формате YYYY-MM-DDThh:mm:ss±hh:mm
 * @returns метка времени
 */
const getTimestamp = () => {
    // можно упростить если есть более быстрый способ без установки сторонних пакетов
    // создаём дату в формате iso YYYY-MM-DDThh:mm:ss
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();
    const isoDate = new Date(Date.UTC(year, month, day, hour, minute, second))
        .toISOString()
        .slice(0, -5);

    // создаём сдвиг часового пояса в формате ±hh:mm
    const regex = /GMT([+-]\d*)/g;
    const [, gtmMatch = ''] = regex.exec(date.toString()) || [];
    const gtmArray = Array.from(gtmMatch);
    gtmArray.splice(3, 0, ':');
    const gtmString = gtmArray.join('');

    return `${isoDate}${gtmString}`;
};

const getAnalytics = (formId: string) => {
    const cookiesMap = {
        ...COOKIES_UTM_MAP,
        gclid: '_ga',
        yclid: '_ym_uid',
        click_id: 'click_id',
    };
    const analytics: Record<string, unknown> = {
        form_id: formId,
        referrer: document.referrer,
    };

    if (window.location.pathname !== '/') {
        analytics.form_url = window.location.pathname;
    }

    const cookiesEntries = Object.entries(cookiesMap).map(([key, cookieName]) => [
        key,
        getCookie(cookieName) ?? '',
    ]);

    return { ...analytics, ...Object.fromEntries(cookiesEntries) };
};

export const createPresaleRequestData = (
    values: Record<string, unknown>,
    formId: string
): ISendFormPresaleRequest => {
    const { email, fio, inn, location, phone } = values;
    const analytics = getAnalytics(formId);
    const phoneNumber = onlyDigits(String(phone));

    return {
        owner_name: fio as string,
        phone: phoneNumber,
        email: email as string,
        inn: inn as string,
        location: location as string,
        source: 'AL_NEW_SITE',
        analytics,
    };
};

const requestsConstants = {
    action: 'create',
    model: 'WITHOUT_VERIFICATION',
    comment: 'null',
};

const requestsDataConstants = {
    creation_method: 'MANUAL',
    source: 'AL_NEW_SITE',
    source_details: 'NOT_PRESALE',
    creator_type: 'CONTRACTOR',
};

export const createDefaultRequestData = (
    values: Record<string, unknown>,
    formId: string,
    innStatus: TInnStatus
): ISendFormDefaultRequest => {
    const { email, fio, inn, location, phone } = values;
    const timestamp = getTimestamp();
    const analytics = getAnalytics(formId);
    const phoneNumber = onlyDigits(String(phone));

    return {
        ...requestsConstants,
        timestamp: timestamp,
        data: {
            ...requestsDataConstants,
            analytics,
            header: {
                phone: phoneNumber,
                email: String(email),
                fio_of_owner: String(fio),
                location: location ? String(location) : undefined,
                inn: innStatus === 'inn_true' ? String(inn) : undefined,
            },
        },
    };
};
